// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CourseTiles_wrapper__BmXaq","main":"CourseTiles_main__v_uwL","item":"CourseTiles_item__6xL3N"};